import { Typography } from "@material-tailwind/react";
import ReportAdminActions from "../../../views/super-admin/views/settings/tabs/reports/ReportAdminActions";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { getReportDataHint } from "./attributeHints";

export default function ReportListItem({
  report,
  onChange,
  isLast = false,
  isReordering = false,
  index,
  labelLookup = {}
}: {
  report: EasyTech.ReportItem,
  onChange: () => void,
  isLast?: boolean,
  isReordering?: boolean,
  index?: number,
  labelLookup?: Record<string, string>
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({
    id: report.id as string,
    disabled: !isReordering
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  const label = labelLookup[report.data] || report.data;
  const hint = getReportDataHint(report.data);

  return (
    <tr 
      ref={setNodeRef} 
      style={style}
      className={`page-list-item ${isLast && "last"} ${isReordering ? "cursor-move relative group" : ""}`}
      {...attributes}
      {...listeners}
    >
      <td>
        <div className="flex gap-2 items-center">
          {isReordering && (
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-gray-400">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
              </svg>
            </div>
          )}
          <Typography>{index !== undefined ? index : report.order}</Typography>
        </div>
      </td>
      <td>
        <div className="flex flex-col">
          <Typography className="font-normal">{label}</Typography>
          {hint && <Typography variant="small" className="text-gray-500">{hint}</Typography>}
        </div>
      </td>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{report.example || "-"}</Typography>
        </div>
      </td>
      <td>
        <ReportAdminActions report={report} onChange={onChange} disabled={isReordering} />
      </td>
    </tr>
  );
}
